import { ConfirmDialogButton } from 'components/ConfirmDialog';
import { trpc } from 'src/trpc';
import { useToast } from 'components/useToast';
import { FC } from 'react';

type Props = {
  orderId: string;
};

export const FailedPaymentNotificationDialog: FC<Props> = ({ orderId }) => {
  const { errorToast, successToast } = useToast();
  const { mutate, isPending } = trpc.admin.order.adminFailedPaymentManualNotification.useMutation({
    onError: (error) => {
      errorToast({ description: error.message });
    },
    onSuccess: () => {
      successToast({ description: 'Customer has been notified.' });
    },
  });

  return (
    <ConfirmDialogButton
      isLoading={isPending}
      bodyText={'Once you confirm, the customer will be notified.'}
      headerText={'Failed Payment Notification'}
      onConfirm={() => mutate(orderId)}
      openButtonText={'Notify Customer'}
      buttonVariant={'secondary'}
    />
  );
};
